<template>
  <div class="overlay"></div>
  <div class="modal-container card-elevated">
    <div class="card-header">
      <div class="header-text">You Have Unsaved Changes</div>
      <span class="material-symbols-outlined close" @click="$emit('close-confirmation')">close</span>
    </div>
    <div class="modal-body">
      <div class="description">{{ description }}</div>
      <div class="button-container">
        <button class="primary-filled-button" @click="$emit('close-confirmation')">No</button>
        <button class="primary-outlined-button" @click="handleConfirm">Yes</button>
      </div>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { defineEmits, defineProps } from 'vue'

const props = defineProps({
  description: {
    type: String,
    required: false,
    default: 'Are you sure you want to navigate away from this page? All unsaved changes will be lost.',
  },
  confirmationCallback: {
    type: Function,
    required: false,
    default: () => { },
  },
})

const emit = defineEmits(['close-confirmation', 'close-drawer'])

const handleConfirm = () => {
  props.confirmationCallback()
  emit('close-drawer')
}
</script>

<style scoped lang="scss">
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 999;
}

.modal-container {
  position: absolute;
  top: 30%;
  left: 30%;
  z-index: 1000;
  background-color: var(--White);
  color: var(--Black);
  width: 40vw;
  margin: auto;
}

.header-text {
  font-size: 1rem;
  color: var(--Grey800);
}

.modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 20px;
}

.close {
  cursor: pointer;
}

.description {
  font-size: 1.1rem;
  font-weight: 500;
  margin: 10px 0 20px 0;

  &span {
    font-weight: 900;
  }
}
</style>
